export const IS_CREATE_BRAND = "IS_CREATE_BRAND";
export const BRAND_LIST = "BRAND_LIST";
export const BRAND_LIST_META = "BRAND_LIST_META";
export const IS_BRAND_LIST_LOADING = "IS_BRAND_LIST_LOADING";
export const IS_BRAND_STATUS_UPDATING = "IS_BRAND_STATUS_UPDATING";
export const AFTER_CREATED = "AFTER_CREATED";
export const AFTER_DELETED = "AFTER_DELETED";
export const AFTER_UPDATED = "AFTER_UPDATED";
export const IS_UPDATE_BRAND = "IS_UPDATE_BRAND";
